<div class="matero-sidebar-header">
  <app-branding></app-branding>
  <span fxFlex></span>
</div>

<div class="matero-sidebar-main scrollbar-none">
  <app-sidemenu></app-sidemenu>
</div>
